import React from 'react';
import { Empty } from 'antd';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

import { formatters } from 'services';
import { ASSET_CLASSES, CDS, REPO, selectors } from 'state';

const AssetPieChart: React.FC = () => {
  const instruments = useSelector(selectors.financialInstrumentsList);
  const data = useSelector(selectors.pnlByAssetClass(instruments));
  // TODO: use this until fixing the backend compute_tactical_allocations
  const dataNoReposNoCDS = data.filter(obj => {
    if (obj.asset_class === REPO || obj.asset_class === CDS) {
    } else {
      return obj;
    }
  });
  if (!data.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const series = dataNoReposNoCDS.map(alloc => alloc.long);
  const labels = dataNoReposNoCDS.map(alloc => {
    return ASSET_CLASSES[alloc.asset_class] ?? 'Other';
  });

  return (
    <div>
      <Chart
        series={series}
        type="pie"
        options={{
          labels,
          chart: {
            animations: {
              enabled: false,
            },
          },
          dataLabels: {
            formatter: (value: number) => value.toFixed(2) + '%',
          },
          tooltip: {
            y: {
              formatter: formatters.million,
              title: {
                formatter: (seriesName: string) => seriesName,
              },
            },
          },
        }}
      />
    </div>
  );
};

export default AssetPieChart;
